import React from 'react';
import { string } from 'prop-types';

export default function Loader({ loaderClassName }) {
    return <div className={`c-loader ${loaderClassName || ''}`} />;
}

Loader.propTypes = {
    loaderClassName: string
};
